import { SearchPages } from '..'
import { HttpServiceResponse } from '../../shared'
import { SearchParams } from '../models/search/search-params.model'
import AbstractApplicationProvider from './application-abstract.provider'

export class SearchProvider extends AbstractApplicationProvider {
  urlPath = 'application_search_api'

  public search<T = any>(page: SearchPages, params: SearchParams): Promise<HttpServiceResponse<T>> {
    const query = this.query.stringify({
      page,
      ...params,
    })

    return this.http.get(`${this.url}?${query}`)
  }
}
